const currentCTAId = {
  id: 'landing',
};

export function setCTAId(id) {
  currentCTAId.id = id;
}

export function getCTAId() {
  return currentCTAId.id;
}
